module.exports = __webpack_public_path__ + "images/loader-big-a770b67.gif";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-widgets/dist/img/loader-big.gif
// module id = 229
// module chunks = 6